$(() => {
  $('input, textarea, select').on('input change', () => {
    window.onbeforeunload = window.onbeforeunload || function () {
      return 'You have unsaved changes.  Do you want to leave this page and lose your changes?';
    };
  });

  $('form').on('submit', () => {
    window.onbeforeunload = null;
  });
});
